import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const PILLARS = [
  {
    title: "Strategy Before Spending",
    body: "Marketing investments should begin with understanding the business, customer, offer, and objective.",
  },
  {
    title: "Technology + Marketing",
    body: "We combine traditional digital marketing with modern automation, AI, analytics, and software capabilities.",
  },
  {
    title: "Scalable Services",
    body: "Begin with an assessment or individual project and expand into ongoing marketing and automation as your needs develop.",
  },
  {
    title: "Human Oversight",
    body: "Technology can accelerate marketing, but important business decisions remain under human oversight.",
  },
  {
    title: "Measurable Objectives",
    body: "Where technically available, campaigns can be connected to measurable indicators such as leads, appointments, conversions, traffic, engagement, and sales.",
  },
];

export const WhyUs = () => (
  <section className="relative py-24 sm:py-32 bg-obsidian-900/50 border-y border-slate-800/60 grain">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>The Difference</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
          Why All In Hand Marketing?
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07} className="h-full">
            <div className="h-full rounded-3xl border border-slate-800 bg-obsidian-800/60 hover:border-gold/40 p-8 transition-all duration-300 hover:-translate-y-1">
              <span className="font-mono text-[10px] text-gold/70 tracking-[0.3em]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-xl font-bold text-white mt-4">{p.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed mt-3">{p.body}</p>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.35} className="h-full">
          <div className="h-full rounded-3xl bg-gradient-to-br from-gold/15 to-emerald-500/10 border border-gold/30 p-8 flex flex-col justify-between">
            <div>
              <p className="font-display text-2xl font-extrabold text-gold-gradient leading-snug">
                Assess. Build. Grow. Scale.
              </p>
              <p className="text-slate-400 text-sm mt-3 leading-relaxed">
                One system, four stages — start at the stage that fits your business today.
              </p>
            </div>
            <button
              data-testid="whyus-cta-assessment"
              onClick={() => scrollToId("assessment")}
              className="mt-8 self-start rounded-full bg-gold text-obsidian font-display font-bold px-6 py-3 text-sm hover:bg-gold-bright transition-colors"
            >
              Start With an Assessment
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhyUs;
